import './style.css';
export const PageSubtitle = ({ image = null, text = null, alignment = "center", children }) => {
    return image ? (
        <div className="d-flex justify-content-center flex-direction-row subtitle-with-image-container">
            {
                image ?
                <div className="recovering-data-box offset-md-0 hidden-mobile" >
                    <img src={image}  alt="Codice Otp"/>
                </div>
                :
                null
            }
            <div className={`subtitle-container col-sm-12 col-md-9`}>
                {
                    text ?
                    <div 
                        dangerouslySetInnerHTML={{__html: text}}
                    >
                    </div>
                    :
                    {children}
                }
            </div>
        </div>
        
    ) :
    (
        <div className={`col-xs-12 subtitle-container-only-text ${alignment}`}>
        {
            text ?
            <div 
                className="subtitle-container__text"
                dangerouslySetInnerHTML={{__html: text}}
            >
            </div>
            :
            <div 
                className="subtitle-container__text"
            >
                {children}
            </div>
        }
    </div>
    )
}